module.exports = __webpack_public_path__ + "img/logocharged.9cc11498.png";